import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { Id } from '../../../../domain/data';

@JsonConverter
export class IdAdapter implements JsonCustomConvert<Id> {
    serialize(id: Id): any | undefined {
        return id ? id.value : undefined;
    }

    deserialize(id: any): Id | undefined {
        return Id.fromString(id);
    }
}
